import { Header } from '@components/Generic'
import { observer } from 'mobx-react'
import { useContext, useEffect } from 'react'
import { StoreContext } from '@store/Root.store'
import { Illustration } from '@/components/Illustration/Illustration'
import { SuccessPage as JointSigningSuccessPage } from './enpal/SuccessEnpalPages/SuccessPage'

const CompletedScreen = observer(() => {
  const store = useContext(StoreContext)
  const { SuccessPage: trans } = store.TranslationsState.translations

  useEffect(() => {
    store.InterfaceState.setSendBeforeunloadEvent(false)
  }, [])

  return (
    <div className="page-container mobile-m-0 vertically-centered">
      <Illustration type="success" />

      <Header className="m-0-0-30">{trans.header}</Header>

      {trans.description && (
        <p className="generic__paragraph-centered m-0-0-30">{trans.description}</p>
      )}
    </div>
  )
})

export const SuccessPage = observer(() => {
  // A failed journey (`?error=true`) keeps the plain completion screen, as before.
  const hasError = new URL(window.location.href).searchParams.has('error')
  if (hasError) return <CompletedScreen />

  // Flows with a signing order (e.g. the two-partner Enpal affordability check) end here. The
  // joint-signing success page already offers the next signatory the "continue on this device"
  // hand-over, so reuse it and only swap in this route's own completion content.
  return <JointSigningSuccessPage completedScreen={<CompletedScreen />} />
})
